import dashboardService from './dashboard.service';

export default {
  default: dashboardService,
};
